import { Component, OnInit } from '@angular/core';
import { HttpQueriesService } from '../Services/http-queries.service';
import { AppComponent } from '../app.component';
import { Router } from '@angular/router';
import { StorageService } from '../Services/storage.service';

@Component({
  selector: 'app-congres-virtuel-auth',
  templateUrl: './congres-virtuel-auth.component.html',
  styleUrls: ['./congres-virtuel-auth.component.scss']
})
export class CongresVirtuelAuthComponent implements OnInit {

  auth = {email:null, pass:null};

  logging = false;

  register = {civilite:null, nom:null, prenom:null, ville:null, pays:null, email:null, type:null, 
              fonction:null, specialite:null, statut:null, societe:null, siteweb:null, password:null, confirm_pass:null, accept_terms:false, congres_id:1};

  saving = false;

  showMsgPopup = {display:false, message:null};

  constructor(private router:Router, private httpservice:HttpQueriesService, private appc:AppComponent, private storagedata:StorageService) { }

  ngOnInit(){
  }

  connect(){
    this.logging = true;
   this.httpservice.congresLogin(this.auth).subscribe(val=>{
      this.logging = false;
      console.log(val)
      this.storagedata.setCongresConUser(val);
      this.router.navigateByUrl('/congres-virtuel');
      this.auth = {email:null, pass:null};

    }, error=>{
      this.logging = false;
        
      if(error.error == 'cred'){
        alert("Email / Mot de passe érroné.");

      }else{
        alert("erreur d'authentification.");

      }

    });


   
  }

  registerMe(){
 if(this.checkIfPassIsGood()){
      this.prepareData();
      this.saving = true;
      this.httpservice.registerCongresMember(this.register).subscribe(val=>{
        this.saving = false;
        this.showMsgPopup = {display:true, message:'Félicitation votre inscription au 25ème congrès de la SMC a été validée avec succès.<br>'+ 
        'Vous pouvez dès à présent vous connecter à la plateforme du congrès en utilisant votre login et votre mot de passe, '+
        'Nous vous souhaitons un bon congrès.'};
        this.register = {civilite:null, nom:null, prenom:null, ville:null, pays:null, email:null, type:null, fonction:null, specialite:null, statut:null, societe:null, siteweb:null, password:null, confirm_pass:null, accept_terms:false, congres_id:1};

      }, error=>{
        this.saving = false;
        
        if(error.error == 'exists'){
          alert("Un utilisateur avec le même email existe déjà.");

        }else{
          alert("erreur d'authentification.");

        }

      });

    }else{
      alert('Les deux mots de passe sont différents!');

    }
    
  }

  preventAction($event){
    $event.preventDefault();
  }

  prepareData(){
    if(this.register.type == 'visiteur'){
      this.register.societe = null;
      this.register.siteweb = null;
   
    }else{
      this.register.specialite = null;
      this.register.statut = null;
   
    }
  }

  checkIfPassIsGood(){
    return (this.register.password == this.register.confirm_pass) ? true : false;
  }

  hideMessage(){
    this.showMsgPopup = {display:false, message:null};
  }

}
